import { useAuth } from '../../auth/hooks/useAuth';
import { Navigate } from 'react-router-dom';
import { useRef } from 'react';
import {
  AnimationClip,
  AnimationMixer,
  LoopPingPong,
  // TextureLoader,
  Mesh,
} from 'three';
import { GLTFLoader } from 'three-stdlib';
import { useAspect } from '@react-three/drei';
import { Canvas, useFrame, useLoader, useThree } from '@react-three/fiber';

interface VoxelSphereProps {
  position: [number, number, number];
}

const VoxelSphere = ({ position }: VoxelSphereProps) => {
  const ref = useRef<Mesh>(null);
  const { scene, animations } = useLoader(
    GLTFLoader,
    '/eggs/VoxelSphere/model/kaddo.gltf'
  );

  const mixer = new AnimationMixer(scene);
  const clip = AnimationClip.findByName(animations, 'Spinning Open');
  const action = mixer.clipAction(clip);
  action.loop = LoopPingPong;
  action.clampWhenFinished = true;
  action.play();

  // Subscribe this component to the render-loop, rotate the mesh every frame
  useFrame((__state, delta) => {
    if (!ref.current) {
      return;
    }

    ref.current.rotation.y += delta;
    mixer.update(delta);
  });

  const { size } = useThree();
  const scale = useAspect(size.width, size.height, 1 / 3)[
    size.width < size.height ? 0 : 1
  ];

  return (
    <primitive ref={ref} position={position} scale={scale} object={scene} />
  );
};

export const Demo = () => {
  const { uid } = useAuth();

  if (uid.length) {
    return <Navigate to="/app/collections" />;
  }

  return (
    <div>
      <Canvas dpr={window.devicePixelRatio}>
        <ambientLight intensity={Math.PI / 2} />
        <spotLight
          position={[10, 10, 10]}
          angle={0.15}
          penumbra={1}
          decay={0}
          intensity={Math.PI}
        />
        <pointLight position={[-10, -10, -10]} decay={0} intensity={Math.PI} />
        <VoxelSphere position={[0, 0, 0]} />
      </Canvas>
    </div>
  );
};
